export const PageNotFound = () => {
  return (
    <div className="flex h-screen items-center justify-center bg-white">
      <h1>Oops! Page Not found</h1>
    </div>
  );
};
